import { createSelector } from 'reselect';

import { Passenger, RefundState } from '../../types';

export const getPassengers = (refundState: RefundState): Passenger[] =>
	Object.entries(refundState.passengers).map(([, value]) => value);

export const getPassengersWithChildren = createSelector(getPassengers, passengers =>
	passengers.filter(passenger => passenger.children?.length > 0)
);

export const getSelectedPassengers = createSelector(getPassengers, passengers =>
	passengers.filter(passenger => passenger.selected)
);

export const getSelectedPassengersIds = createSelector(getSelectedPassengers, passengers =>
	passengers.map(passenger => passenger.id)
);

export const getHasSelectedPassengers = createSelector(getSelectedPassengers, passengers => passengers.length > 0);

export const getSelectedPassengersWithChildrenIds = createSelector(
	getSelectedPassengers,
	(selectedPassengers): number[] => {
		const selectedIds = new Set<number>();

		selectedPassengers.forEach(passenger => {
			const passengerId = Number(passenger.id);

			selectedIds.add(passengerId);

			if (passenger.children?.length) {
				passenger.children.forEach(child => selectedIds.add(Number(child.id)));
			}
		});

		return [...selectedIds];
	}
);
